export default function (instance) {
    return {
        getStaticSchedule(params) {
            return instance.get('/staticschedule/get', { params });
        }
    }
}